import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import { Menu, MenuItem, TextField } from "@mui/material"
import { ApiRoutesNames } from 'bets.oddprovider.lib.common.ts/api/routes'
import { ImageComponent } from "fwork.react.apptemplate"
import { useSnackbar } from 'notistack'
import React, { useState } from "react"
import { useSelector } from "react-redux"
import imgDefault from '../../assets/escudo.jpg'
import { DEFAULTGAP } from '../../globals'
import { IDotEnvProductionState } from '../../redux/reducers/dotenvProduction.slice'
import { RootState } from '../../redux/store'
import { uuidv7 } from 'uuidv7'

interface ParticipantImgComponentProps {
  onFileChange: (file: File | null) => void
  id?: number,
}

export const ParticipantImgComponent = ({ onFileChange, id }: ParticipantImgComponentProps) => {
  const dotEnvProductionState: IDotEnvProductionState = useSelector((state: RootState) => state.dotEnvProductionState)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const { enqueueSnackbar } = useSnackbar()

  const imageUrl = `https://assets.aposte.bet/${id}_b.png?v=${uuidv7()}`

  const [image, setImage] = useState(id ? imageUrl : imgDefault)

  const handleClick = (event: React.MouseEvent<HTMLImageElement>) => setAnchorEl(event.currentTarget)

  const handleClose = () => setAnchorEl(null)

  const handleSelectImgChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null

    if (file) {
      const reader = new FileReader()
      reader.onload = () => setImage(reader.result)
      reader.readAsDataURL(file)
    } else {
      setImage(id ? imageUrl : imgDefault)
    }

    onFileChange(file)
    handleClose()
  }

  const convertUrlToFile = async (url: string): Promise<File | null> => {
    try {
      const response = await fetch(url)
      const blob = await response.blob()
      return new File([blob], 'image.png', { type: 'image/png' })
    } catch (error) {
      enqueueSnackbar('Acesso a imagem negado, tente novamente', { variant: 'error' })
      return null
    }
  }

  const handleImageUrlChange = async (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const imageUrl = e.target.value
    const file = await convertUrlToFile(`${dotEnvProductionState.payload?.APIURL}${ApiRoutesNames.webproxy.replace(':url', encodeURIComponent(imageUrl))}`)
    if (file) {
      // setImage({ url: imageUrl })
      setImage(imageUrl)
      onFileChange(file)
    }
    handleClose()
  }

  return (
    <>
      <ImageComponent
        src={image}
        onError={() => setImage(imgDefault)}
        style={{ maxWidth: '100px', maxHeight: '100px', cursor: 'pointer' }}
        onClick={handleClick}
      />
      <Menu
        sx={{
          '&:hover': { backgroundColor: 'inherit' }
        }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <MenuItem onClick={() => document.getElementById("fileInput")?.click()} style={{ gap: 10, width: 350, paddingBlock: 10 }}>
          <div style={{ display: 'flex', gap: DEFAULTGAP }}>
            <CloudUploadIcon />
            <div> Selecionar Imagem</div>
          </div>
          <input
            id="fileInput"
            type="file"
            onChange={handleSelectImgChange}
            accept='image/png'
            style={{ display: 'none' }}
          />
        </MenuItem>

        <MenuItem
          disableRipple
          sx={{
            '&:hover': {
              backgroundColor: 'inherit'
            }
          }}
          style={{ marginTop: 10 }}>
          <TextField
            size='small'
            placeholder="Cole a url da imagem aqui..."
            onChange={handleImageUrlChange}
            style={{ width: '100%', boxSizing: 'border-box' }}
          />
        </MenuItem>
      </Menu>
    </>
  )
}
